import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TITLE_SELECTOR } from '../constants/CardSeleniumSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TruncatedTitle({
  title
}) {
  if (typeof title === 'string') {
    return /*#__PURE__*/_jsx("div", {
      style: {
        minWidth: '3rem'
      },
      children: /*#__PURE__*/_jsx(TruncateString, {
        "data-selenium-test": TITLE_SELECTOR,
        children: title
      })
    });
  }
  if (title) {
    return /*#__PURE__*/_jsx("span", {
      "data-selenium-test": TITLE_SELECTOR,
      children: title
    });
  }
  return null;
}